
let BASE_URL = 'http://localhost:3008'
// Same-origin in production: staging/prod serve the frontend and proxy /api and
// /api/v1 to the new Supabase-backed backend via nginx. (Was hardcoded to the
// old legacy VPS 'https://avahservices.com/service', which silently sent every
// call to the old Postgres — see docs/otp_supabase_migration_plan.md.)
let PRODUCTION_URL = ''

const replaceUrl =(url)=>{
    if(process.env.NODE_ENV=='production'){
        return url.replace(BASE_URL,PRODUCTION_URL)
    }
    return url
}

// New Supabase-native auth (OTP login for all roles + registration). In dev these
// resolve to http://localhost:3008/...; in prod to same-origin /... (nginx-proxied).
const AUTH = {
    customer_send_otp:     replaceUrl(`${BASE_URL}/api/v1/auth/customer/otp`),
    customer_verify_otp:   replaceUrl(`${BASE_URL}/api/v1/auth/customer/otp/verify`),
    vendor_send_otp:       replaceUrl(`${BASE_URL}/api/v1/auth/vendor/otp`),
    vendor_verify_otp:     replaceUrl(`${BASE_URL}/api/v1/auth/vendor/otp/verify`),
    admin_send_otp:        replaceUrl(`${BASE_URL}/api/v1/auth/admin/otp`),
    admin_verify_otp:      replaceUrl(`${BASE_URL}/api/v1/auth/admin/otp/verify`),
    customer_register_otp: replaceUrl(`${BASE_URL}/api/v1/auth/customer/register/otp`),
    customer_register:     replaceUrl(`${BASE_URL}/api/v1/auth/customer/register`),
    vendor_register_otp:   replaceUrl(`${BASE_URL}/api/v1/auth/vendor/register/otp`),
    vendor_register:       replaceUrl(`${BASE_URL}/api/v1/auth/vendor/register`),
}

// console.log("ln 12 ", PRODUCTION_URL)

const URL = {
    AUTH,
    LOGIN_REGISTER:{
        login_admin:replaceUrl(`${BASE_URL}/api/admin/login`),
        login_service_provider:replaceUrl(`${BASE_URL}/api/serviceprovider/login`),
        login_customer : replaceUrl(`${BASE_URL}/api/customer/login`),
        register_service_provider:replaceUrl(`${BASE_URL}/api/serviceprovider/registerServiceProvider`),
        register_customer:replaceUrl(`${BASE_URL}/api/customer/registerCustomer`),
        getAllCitiesPerState : replaceUrl(`${BASE_URL}/api/customer/getAllCitiesPerState`),
        customerResetPassword : replaceUrl(`${BASE_URL}/api/customer/resetPassword`),
        serviceprovideResetPassword : replaceUrl(`${BASE_URL}/api/serviceprovider/resetPassword`),
        adminResetPassword : replaceUrl(`${BASE_URL}/api/admin/resetPassword`),
        getAllBrandsMultiSelect : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllBrandsMultiSelect`)

    },
    ADMIN:{
        HOME:{
            getStatistics : replaceUrl(`${BASE_URL}/api/admin/getStatistics`)
        },
        USER:{
            CUSTOMER:{
                getAllCustomers :  replaceUrl(`${BASE_URL}/api/admin/getAllCustomers`)

            },
            SERVICEPROVIDER:{
                getAllApprovedSp : replaceUrl(`${BASE_URL}/api/admin/getAllApprovedSp`),
                getAllRejectedSp : replaceUrl(`${BASE_URL}/api/admin/getAllRejectedSp`),
                getSpecificApprovedSpDocument : replaceUrl(`${BASE_URL}/api/admin/getSpecificApprovedSpDocument`),
                getSpecificRejectedSpDocument :  replaceUrl(`${BASE_URL}/api/admin/getSpecificRejectedSpDocument`)
               
            }
        },
        VEHICLESETTINGS:{
            FUELTYPE:{
                getAllFuelTypes : replaceUrl(`${BASE_URL}/api/admin/getAllFuelTypes`),
                createFuelType : replaceUrl(`${BASE_URL}/api/admin/createFuelType`)

            },
            MANUFACTURER:{
                createBrand : replaceUrl(`${BASE_URL}/api/admin/createBrand`),
                getAllBrands : replaceUrl(`${BASE_URL}/api/admin/getAllBrands`)

            },
            MODELS:{
                getAllModels : replaceUrl(`${BASE_URL}/api/admin/getAllModels`),
                getAllBrandsAutoFill : replaceUrl(`${BASE_URL}/api/admin/getAllBrandsAutoFill`),
                getAllFuelTypeAutoFill : replaceUrl(`${BASE_URL}/api/admin/getAllFuelTypeAutoFill`),
                createModel : replaceUrl(`${BASE_URL}/api/admin/createModel`)

            }
        },
        REQUESTS:{
            PENDINGREQUESTS:{
                approveServiceProvider : replaceUrl(`${BASE_URL}/api/admin/approveServiceProvider`)    ,
                spRequest : replaceUrl(`${BASE_URL}/api/admin/spRequest`),
                getSpecificPendingSpDocument : replaceUrl(`${BASE_URL}/api/admin/getSpecificPendingSpDocument`)
            }
        }
    },
    SERVICE_PROVIDER:{
        HOME:{
            getStatistics : replaceUrl(`${BASE_URL}/api/serviceprovider/getStatistics`)
        },
        USERS:{
            CUSTOMER:{

            },
            EMPLOYEES:{
                getAllEmployee : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllEmployee`),
                createEmployee :replaceUrl(`${BASE_URL}/api/serviceprovider/createEmployee`),
                getAllPermissionPerRoles : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllPermissionPerRoles`),
                updateEmployee : replaceUrl(`${BASE_URL}/api/serviceprovider/updateEmployee`),
                deleteEmployee :replaceUrl(`${BASE_URL}/api/serviceprovider/deleteEmployee`)

            }
        },
        SPARES : {
            addspare: replaceUrl(`${BASE_URL}/api/serviceprovider/addspare`),
            getAllSpares : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllSpares`),
            getAllFuelTypes:replaceUrl(`${BASE_URL}/api/admin/getAllFuelTypes`),
            deleteSpare : replaceUrl(`${BASE_URL}/api/serviceprovider/deleteSpare`),
        },
        LABOURS : {
            addlabour: replaceUrl(`${BASE_URL}/api/serviceprovider/addlabour`),
            getAllLabour : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllLabour`),
            deleteLabour : replaceUrl(`${BASE_URL}/api/serviceprovider/deleteLabour`),
        },
        ROLE:{
            addEmployeeRole : replaceUrl(`${BASE_URL}/api/serviceprovider/addEmployeeRole`),
            getAllEmployeeRoles : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllEmployeeRoles`),
            deleteEmployeeRole : replaceUrl(`${BASE_URL}/api/serviceprovider/deleteEmployeeRole`),
            editEmployeeRole :  replaceUrl(`${BASE_URL}/api/serviceprovider/editEmployeeRole`)

        },  
        SERVICE:{
            ESTIMATE:{
                getAllSpareListForAutoFill: replaceUrl(`${BASE_URL}/api/serviceprovider/getAllSpareListForAutoFill`),
                getSpecificSpareDetailsForEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificSpareDetailsForEstimate`),
                getAllLabourListForAutoFill : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllLabourListForAutoFill`),
                getSpecificLabourDetailsForEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificLabourDetailsForEstimate`),
                addEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/addEstimate`),
                getEstimatePendingVehcileList : replaceUrl(`${BASE_URL}/api/serviceprovider/getEstimatePendingVehcileList`),
                getSpecificVechicleDetailsToCreateEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificVechicleDetailsToCreateEstimate`),
                getAllCreatedEstimateList : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllCreatedEstimateList`),
                getEstimateDetails : replaceUrl(`${BASE_URL}/api/serviceprovider/getEstimateDetails`),
                editEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/editEstimate`),
                approveCustAppointment : replaceUrl(`${BASE_URL}/api/serviceprovider/approveCustAppointment`),



            },
            APPOINTMENT:{
                addEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/addEstimate`),
                getAllLabourListForAutoFill : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllLabourListForAutoFill`),
                getAllSpareListForAutoFill: replaceUrl(`${BASE_URL}/api/serviceprovider/getAllSpareListForAutoFill`),
                getSpecificSpareDetailsForEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificSpareDetailsForEstimate`),
                getSpecificLabourDetailsForEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificLabourDetailsForEstimate`),
                getAllVehicleList : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllVehicleList`),
                getSpecificVehicleDetailsForSpAppt : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificVehicleDetailsForSpAppt`),
                createAppointment: replaceUrl(`${BASE_URL}/api/customer/createAppointment`),
                getAllPendingAppointment : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllPendingAppointment`),
                getAllRejectedAndCancelledAppointment : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllRejectedAndCancelledAppointment`),
                approveCustAppointment : replaceUrl(`${BASE_URL}/api/serviceprovider/approveCustAppointment`),
                createEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/createEstimate`),
                getAllModelPerBrand : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllModelPerBrand`),
            },
            JOBCARD:{
                getJobcardDetails : replaceUrl(`${BASE_URL}/api/serviceprovider/getJobcardDetails`),
                updateJobcard : replaceUrl(`${BASE_URL}/api/serviceprovider/updateJobcard`),
                getAllTechnicianEmployee : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllTechnicianEmployee`),
                getAllAdminAdvisorEmployee : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllAdminAdvisorEmployee`),
                getAllCreatedJobcardList :replaceUrl(`${BASE_URL}/api/serviceprovider/getAllCreatedJobcardList`),
                getAllSpareListForAutoFill: replaceUrl(`${BASE_URL}/api/serviceprovider/getAllSpareListForAutoFill`),
                getSpecificSpareDetailsForEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificSpareDetailsForEstimate`),
                getAllLabourListForAutoFill : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllLabourListForAutoFill`),
                getSpecificLabourDetailsForEstimate : replaceUrl(`${BASE_URL}/api/serviceprovider/getSpecificLabourDetailsForEstimate`),
                generateInvoice :   replaceUrl(`${BASE_URL}/api/serviceprovider/generateInvoice`),
                approveCustAppointment : replaceUrl(`${BASE_URL}/api/serviceprovider/approveCustAppointment`),

            }
        },
        BILLING : {
            PENDINGPAYMENTS : {
                getAllPendingPaymentInvoices : replaceUrl(`${BASE_URL}/api/serviceprovider/getAllPendingPaymentInvoices`),
                getJobcardDetails : replaceUrl(`${BASE_URL}/api/serviceprovider/getJobcardDetails`),
                recievePayment : replaceUrl(`${BASE_URL}/api/serviceprovider/recievePayment`),
                approveCustAppointment : replaceUrl(`${BASE_URL}/api/serviceprovider/approveCustAppointment`),
            },
            PAIDINVOICES : {
                getAllPaidInvoices: replaceUrl(`${BASE_URL}/api/serviceprovider/getAllPaidInvoices`),
                getJobcardDetails : replaceUrl(`${BASE_URL}/api/serviceprovider/getJobcardDetails`),
                approveCustAppointment : replaceUrl(`${BASE_URL}/api/serviceprovider/approveCustAppointment`),

            }

        },
        NOTIFICATION:{
            getNotificationNumbers : replaceUrl(`${BASE_URL}/api/serviceprovider/getNotificationNumbers`)
        },
        REVIEW:{
            getServiceProviderFeedbackWithAvg: replaceUrl(`${BASE_URL}/api/serviceprovider/getServiceProviderFeedbackWithAvg`)
        }

    },
    CUSTOMER:{
        HOME:{
            getStatistics : replaceUrl(`${BASE_URL}/api/customer/getStatistics`)
        },
        LANDINGPAGE:{
            getRandomSp : replaceUrl(`${BASE_URL}/api/customer/getRandomSp`),
            getEstimateDetails : replaceUrl(`${BASE_URL}/api/serviceprovider/getEstimateDetails`),
            getGeneralStatistics :   replaceUrl(`${BASE_URL}/api/customer/getGeneralStatistics`),
            searchServiceProvidersHomepage : replaceUrl(`${BASE_URL}/api/serviceprovider/searchServiceProvidersHomepage`)
        },
        VEHICLE:{
            getAllModelPerBrand:replaceUrl(`${BASE_URL}/api/serviceprovider/getAllModelPerBrand`),
            getAllFuelTypes:replaceUrl(`${BASE_URL}/api/admin/getAllFuelTypes`),
            vehicleRegistration:replaceUrl(`${BASE_URL}/api/customer/vehicleRegistration`),
            getCustomerVehicle : replaceUrl(`${BASE_URL}/api/customer/getCustomerVehicle`),
            // Supabase-native (C2) — replaces vehicleRegistration above, which relied on a
            // fragile email-lookup + legacy compat view/trigger. Auth'd by the OTP JWT
            // (customerId), not a request-body email. See docs/otp_supabase_migration_plan.md.
            addVehicle: replaceUrl(`${BASE_URL}/api/v1/customers/me/vehicles`),
        },
        UPDATEPROFILE:{
            getAllCitiesPerState:replaceUrl(`${BASE_URL}/api/customer/getAllCitiesPerState`),
            getCustomerProfile:replaceUrl(`${BASE_URL}/api/customer/getCustomerProfile`),
            profileCompletion:replaceUrl(`${BASE_URL}/api/customer/profileCompletion`),
            // Supabase-native (C3/C4) — replaces the two above, which relied on the same
            // fragile email-lookup pattern as the old vehicleRegistration endpoint.
            getMe: replaceUrl(`${BASE_URL}/api/v1/customers/me`),
            updateMe: replaceUrl(`${BASE_URL}/api/v1/customers/me`),
        },
        APPOINTMENT:{
            getEstimateDetails : replaceUrl(`${BASE_URL}/api/serviceprovider/getEstimateDetails`),
            estimateApproval : replaceUrl(`${BASE_URL}/api/customer/estimateApproval`),
            estimateRejection : replaceUrl(`${BASE_URL}/api/customer/estimateRejection`),
            createAppointment :  replaceUrl(`${BASE_URL}/api/customer/createAppointment`),
            getJobcardDetails : replaceUrl(`${BASE_URL}/api/serviceprovider/getJobcardDetails`),
            getAllPendingApprovedAppointment : replaceUrl(`${BASE_URL}/api/customer/getAllPendingApprovedAppointment`),
            getAllRejectedCancelledAppointment : replaceUrl(`${BASE_URL}/api/customer/getAllRejectedCancelledAppointment`),
            getSpDetailsPerCity : replaceUrl(`${BASE_URL}/api/customer/getSpDetailsPerCity`),
            getCustomerVehicleNumbers : replaceUrl(`${BASE_URL}/api/customer/getCustomerVehicleNumbers`),
            vehicleSearch : replaceUrl(`${BASE_URL}/api/customer/vehicleSearch`),
           
        },
        REVIEW:{
            getPaidServices: replaceUrl(`${BASE_URL}/api/customer/getPaidServices`),
            rateServiceProvider:replaceUrl(`${BASE_URL}/api/customer/rateServiceProvider`)
        }
    }

}

export default URL